var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.50382 17.8824L7.27875 18.4885L9.69262 25.7412C9.81847 26.135 10.0842 26.469 10.4395 26.6802L10.5274 26.731C10.9303 26.9221 11.3896 26.9578 11.8171 26.8311L16.9329 25.1756C17.1462 25.1082 17.344 24.9993 17.5149 24.8551C17.6858 24.7108 17.8263 24.5341 17.9285 24.3352C18.0306 24.1362 18.0923 23.919 18.1099 23.6961C18.1276 23.4731 18.1009 23.2489 18.0313 23.0364L17.2364 20.6244L23.4506 22.0053C23.6996 22.059 23.9576 22.0558 24.2053 21.9959C24.4529 21.936 24.6839 21.8209 24.8808 21.6592C25.0768 21.4999 25.2346 21.2988 25.3427 21.0706C25.4508 20.8424 25.5065 20.5928 25.5055 20.3403L25.4965 4.45697C25.4968 4.20403 25.4403 3.95426 25.3312 3.72604C25.2222 3.49783 25.0633 3.29699 24.8663 3.1383C24.6694 2.97961 24.4393 2.86711 24.1931 2.80909C23.9469 2.75108 23.6909 2.74902 23.4438 2.80307L4.52929 6.9797C4.1524 7.06286 3.81529 7.27241 3.57391 7.57357C3.33254 7.87473 3.20142 8.24939 3.20233 8.63534L3.20442 16.1752C3.19017 16.5662 3.31188 16.9499 3.5488 17.2612C3.78572 17.5725 4.12322 17.792 4.50382 17.8824ZM14.2342 22.5433L12.3328 23.1642L11.0994 19.3468L13.3735 19.8394L14.2342 22.5433ZM22.0778 6.62357L22.0571 18.3298L6.4809 14.8639L6.50669 10.0158L22.0778 6.62357Z",
    fill: "#8AB1BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.5ffbaa0a2c6b4a11c5b9957ea28fff11.svg";
export { ForwardRef as ReactComponent };